import { CancelOnCallRequest } from '~/domain/usecases/onCallRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  Conflict,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteCancelOnCallRequest implements CancelOnCallRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<CancelOnCallRequest.Model>;

  constructor(url: string, httClient: HttpClient<CancelOnCallRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  cancel = async (
    params: CancelOnCallRequest.Params,
  ): Promise<CancelOnCallRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.onCallId}/requests/${params.requestId}/CANCEL`,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.conflict:
        throw new Conflict();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
